document.addEventListener('DOMContentLoaded', function () {
  const mainSizeSelector = document.getElementById('main-product-size');
  const bundleVariantInput = document.getElementById('bundle-product-variant-id');

  const bundleProductHandle = 'contra-heist-roof-runner-1'; // ← CHANGE THIS

  let bundleVariants = [];

  fetch(`/products/${bundleProductHandle}.js`)
    .then(res => res.json())
    .then(data => {
      bundleVariants = data.variants;

      if (mainSizeSelector?.value) {
        const match = bundleVariants.find(v => v.option1 === mainSizeSelector.value);
        if (match) bundleVariantInput.value = match.id;
      }
    });

  mainSizeSelector?.addEventListener('change', function () {
    const selected = this.value;
    const match = bundleVariants.find(v => v.option1 === selected);
    if (match) bundleVariantInput.value = match.id;
  });
});
  // Add-to-cart override
  const form = document.querySelector('form[data-type="add-to-cart-form"]');

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const bundleVariantId = bundleVariantInput.value;
      const quantity = formData.get('quantity') || 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: mainVariantId, quantity: parseInt(quantity, 10) },
            { id: bundleVariantId, quantity: 1 }
          ]
        })
      })
      .then(res => {
        if (res.ok) {
          window.location.href = '/cart'; // or open cart drawer here if using one
        } else {
          res.json().then(data => {
            alert(data.description || 'There was an error adding to cart.');
          });
        }
      })
      .catch(() => alert('Could not add products to cart.'));
    });
  }
